<template>
  <div id="exhpredictionList">
    <div id="tableView" v-loading="this.loading" element-loading-text="加载中">
			<el-row>
        <el-form label-width="75px" :inline="true" class="el-form demo-form-inline">
          <el-row>
            <el-col :span="1">&nbsp;</el-col>
            <el-col :span="11" class="searchInline">
              <label class="el-form-item__label searchLabel">企业名称</label>
              <el-input size="small" v-model="searchForm.qymc" placeholder="企业名称" clearable></el-input>
            </el-col>
          </el-row>
          <div>
            <el-form>
              <el-col :span="12" class="btnEditDelete">
                <el-form-item align="left">
                  <el-button v-if="hasPermission('council/membersList:add')" type="success" icon="el-icon-plus" size="small" @click="addClick">新增</el-button>
                  <el-button v-if="hasPermission('council/membersList:delete')" type="danger" icon="el-icon-delete" size="small" @click="deleteClick">删除</el-button>
                  <el-button v-if="hasPermission('council/membersList:import')" type="primary" icon="el-icon-upload" size="small" @click="importClick">导入</el-button>
                  <el-button  type="warning" icon="el-icon-download" size="small" @click="exportClick">导出</el-button>
                </el-form-item>
              </el-col>
              <el-col :span="12" class="btnSearchPlus">
                <el-form-item>
                  <el-button type="primary" icon="el-icon-search" size="small" @click="searchClick">查询</el-button>
                  <el-button type="clear" icon="el-icon-refresh" size="small" @click="clearClick">重置</el-button>
                </el-form-item>
              </el-col>
            </el-form>
          </div>
        </el-form>
      </el-row>
			<div class="table_container">
        <el-table class="tableStyle" border id="table" :data="tableData.slice((currentPage-1)*pageSize,currentPage*pageSize)" @selection-change="selectionChange"
          :height="tableheight" tooltip-effect="dark" :row-style="rowStyle">
          <el-table-column type="selection" width="35"></el-table-column>
          <el-table-column prop="xh" label="序号" show-overflow-tooltip width="65" align="center"></el-table-column>
          <el-table-column prop="qymc" label="企业名称" show-overflow-tooltip min-width="25%" align="center"></el-table-column>
          <el-table-column prop="tyshxydm" label="统一社会信用代码" show-overflow-tooltip min-width="23%" align="center"></el-table-column>
          <el-table-column label="操作" width="75" align="center" v-if="hasPermission('council/membersList:edit')">
            <template slot-scope="scope">
              <el-button type="text" @click="editClick(scope.row)">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--翻页组件-->
        <el-row type="flex" justify="end">
          <paginator v-if="tableData.length>0"></paginator>
        </el-row>
			</div>

      <!-- 行业信用等级 -->
      <el-dialog :title="title" :visible.sync="open" :close-on-click-modal="false">
        <el-form :model="form" label-width="140px" :rules="rules" ref="form">
          <el-form-item prop="xh" label="序号">
            <el-input size="small" v-model="form.xh" placeholder="序号" clearable></el-input>
          </el-form-item>
          <el-form-item prop="qymc" label="企业名称">
            <el-input size="small" v-model="form.qymc" placeholder="企业名称" clearable></el-input>
          </el-form-item>
          <el-form-item prop="tyshxydm" label="统一社会信用代码">
            <el-input size="small" v-model="form.tyshxydm" placeholder="统一社会信用代码" clearable></el-input>
          </el-form-item>
        </el-form>
        <el-row class="buttonSubmit">
          <el-button type="clear" icon="el-icon-close" size="small" class="btn_submit" @click="closeDialog()">取消</el-button>
          <el-button type="success" icon="el-icon-check" size="small" @click="save">保存</el-button>
        </el-row>
      </el-dialog>

      <el-dialog title="理事单位导入" :visible.sync="openImport" :close-on-click-modal="false" :append-to-body="true">
        <div style="min-height:200px;margin-top:20px">
          <i class="el-icon-info"></i>&nbsp;
          <span>
            说明：请先下载模板，在模板中编辑数据后导入。需注意统一社会信用代码前后不要包含空格，以免导入失败。
          </span>
          <br>
          <div style="margin-top:30px;">

            <a style="font-size:16px;margin:0px 10px" href="/static/templates/理事单位导入模板.xlsx">下载模板</a>
            <!-- <el-button type="primary" icon="el-icon-download" size="small" @click="downloadFile">下载模板</el-button> -->
            <br><br>
            <el-upload
              v-if="hasPermission('council/membersList:import')"
              style="display: inline-block; margin: 0 10px"
              action="#"
              :show-file-list="false"
              :on-change="handleExcel"
              accept=".xlsx, .xls"
              :auto-upload="false"
              :headers="headers">
              <el-button v-if="hasPermission('council/membersList:import')" type="primary" icon="el-icon-upload" size="small">导入</el-button>
            </el-upload>
          </div>
          
      
        </div>
        
        
      </el-dialog>
      <a id = "downPdf" v-show="false"></a>
		</div>
  </div>
</template>
<script>
//引入翻页 paginator
import paginator from '@/components/paginator'
export default {
  components: {
    paginator
  },
  data() {
    return {
      that: this,
      //当前登陆用户
      currentUser: this.CONSTANT.currentUser,
      //搜索表单
      searchForm: {
        qymc: "",
        rhsj: ""
      },
      exportForm: [],
      tableData: [],
      //表高度变量
      tableheight: this.CONSTANT.tableheight10,
      imgViewVisible: false,
      //多选值
      multipleSelection: [],
      //显示加载中样
      loading: false,
      //当前页
      currentPage: 1,
      //分页大小
      pageSize: 10,
      //总记录数
      total: 0,
      // 导入设置headers
      headers: {"Content-Type": "multipart/form-data;charset=UTF-8", XTOKEN: localStorage.getItem("XTOKEN")},
      // 新增信用等级form
      form: {
        qymc: "",
        tyshxydm: "",
        xh: ""
      },
      rules: {
        qymc: [
          { required: true, message: "请输入企业名称", trigger: "blur" },
          {
            max: 200,
            message: "企业名称最多为200字符",
            trigger: "blur"
          }
        ],
        tyshxydm: [
          { required: true, message: "请输入统一社会信用代码", trigger: "blur" },
          {
            pattern: /^[0-9A-Za-z]{18}$/,
            message: "统一社会信用代码应为18位字母、数字",
            trigger: "blur"
          }
        ],
        xh: [
          { required: true, message: "请输入序号", trigger: "blur" },
          {
            pattern: /^[0-9]{1,5}$/,
            message: "序号应为最多5位数字格式",
            trigger: "blur"
          }
        ],
      },
      open: false,
      title: "",
      openImport: false
    };
  },
  created: function() {
    if(this.$store.state.listPagePars.has(this.$route.path)){
        this.searchForm = this.$store.state.listPagePars.get(this.$route.path);
        this.currentPage = this.searchForm.pageNum;
        this.pageSize = this.searchForm.pageSize;
      }
    this.searchClick('page');
  },
  methods: {
    //表格查询事件
    searchClick: function(type) {
      let vm = this;
      this.tableData = [];
      if (type != 'page') {
        this.currentPage = 1;
      }
      vm.loading = true;//表格重新加载
      var params = {
        qymc_like: vm.searchForm.qymc.replace(/%/g, "\\%"),
        pageSize: vm.pageSize,
        pageNum: vm.currentPage
      }
      vm.$axios.post('/cfpalsdw/page', params).then(function (res) {
        var tableTemp = new Array((vm.currentPage-1)*vm.pageSize);
        vm.tableData = tableTemp.concat(res.data.result.list);
        this.total = res.data.result.total;
        this.exportForm = [this.searchForm.qymc.replace(/%/g, "\\%"),"0"];
        this.loading = false;
        this.$store.dispatch('saveListPagePars', {path: this.$route.path, pars: params});
      }.bind(this), function (error) {
        console.log(error)
      })
    },

    //清空查询条件
    clearClick: function() {
      this.searchForm.qymc = '';
      this.searchClick('reset');
    },

    //表格勾选事件
    selectionChange: function(val) {
      this.multipleSelection = val;
    },
    //新增事件
    addClick: function() {
      this.form = {
        qymc: "",
        tyshxydm: "",
        xh: ""
      }
      this.title = "新增理事单位"
      this.open = true
    },

    //表格修改事件
    editClick: function(val, index) {
      this.$axios.get("cfpalsdw/" + val.uuid).then(res => {
        if (res.data.code == "00000000") {
          this.form = res.data.result
          this.title = "编辑理事单位"
          this.open = true
        }
      })
    },

    //删除所选，批量删除
    deleteClick: function() {
      this.$confirm('确定删除已选中理事单位信息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let vm = this;
        for (var i in this.multipleSelection) {
          vm.multipleSelection[i].xgrid = this.currentUser.userid;
          vm.multipleSelection[i].xgrmc = this.currentUser.username;
          vm.multipleSelection[i].deleteFlag = 'Y';
        }
        vm.$axios.post('/cfpalsdw/doDeleteLsdwList', vm.multipleSelection).then(function (res) {
          vm.$message({
            message: "成功删除" + res.data.result + "条理事单位信息",
            showClose: true,
            onClose: this.searchClick('delete')
          });
        }.bind(this), function (error) {
          console.log(error)
        })
      }).catch(() => {
        vm.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },

    //关闭Dialog
    closeDialog: function() {
      this.$refs["form"].resetFields();
      this.searchClick('page');
      this.open = false;
    },
    // 保存
    save () {
      this.$refs["form"].validate((valid) => {
        if(valid) {
          if (!this.form.uuid) {
            this.form.cjrid = this.currentUser.userid;
            this.form.cjrmc = this.currentUser.username;
            this.$axios.post("cfpalsdw/insertLsdwByVO", this.form).then(res => {
              if (res.data.code == "00000000") {
                this.$message.success("新增成功")
                this.open = false
                this.searchClick("add")
              } else {
                this.$message.error(res.data.msg)
              }
            }).catch(err => {
              this.$message.error("新增失败")
            })
          } else {
            this.form.xgrid = this.currentUser.userid;
            this.form.xgrmc = this.currentUser.username;
            this.$axios.post("/cfpalsdw/doUpdateLsdwByVO", this.form).then(res => {
              if (res.data.code == "00000000") {
                this.$message.success("编辑成功")
                this.open = false
                this.searchClick("page")
              } else {
                this.$message.error(res.data.msg)
              }
            }).catch(err => {
              this.$message.error("编辑失败")
            })
          }
        }
      })
    },
    //导出
    // exportClick: function () {
    //   window.open(window.config.domain + "/qyjbxx/doExportJbxx/" + this.exportForm);
    // },
    // 导入
    handleExcel (file) {
      this.$confirm('是否确认导入该文件?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        let formData = new FormData(); //声明一个FormDate对象
        formData.append("file", file.raw);    //把文件信息放入对象中
        this.$axios.post("/cfpalsdw/importExcel", formData).then(res => {
          if (res.data.code == "00000000") {
            this.$message.success("导入成功");
            this.loading = false
            this.openImport = false;
            this.searchClick('click');
          } else {
            this.loading = false
            this.$message.error(res.data.result)
          }
        }).catch(err => {
          this.loading = false
          this.$message.error('导入失败')
        })
      })
    },
    // 下载模板
    downloadFile () {
      this.$axios.get("cfpalsdw/downloadExcel", { responseType: "blob"}).then(res => {
        var a = document.getElementById("downPdf");
        let blob = new Blob([res.data], {
          type: "application/vnd.ms-excel;charset-UTF-8",
        });
        const blobUrl = URL.createObjectURL(blob);
        a.href = blobUrl;
        a.download = "理事单位信息.xlsx";
        a.click();
        URL.revokeObjectURL(blobUrl);
      })
    },
    importClick: function(){
      this.openImport = true;
    },
    //导出
    exportClick: function () {
      window.open(window.config.domain + "/cfpalsdw/doExport/" + this.exportForm);
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/views/exhibition/prediction/council/membersList.vue